module.exports = __webpack_public_path__ + "static/media/valenti-back.00b53443.png";